import { Box } from "@mui/material";

import { usePclContext } from "../../context/PclContextProvider";

import MaintenanceListItem from "./MaintenanceListItem";
import ProductListItem from "./ProductListItem";

export default function ProductListView() {
  const { products } = usePclContext();

  return (
    <Box display="flex" flexDirection="column" sx={{ flex: 1 }}>
      {products?.map((card) => {
        if (!card) return;
        return (
          <Box key={card.product_id} sx={{ margin: 1, flex: 1 }}>
            {card?.active_maintenances?.length === 0 ? (
              <ProductListItem listItem={card} />
            ) : (
              <MaintenanceListItem listItem={card} />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
